var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"app-content",attrs:{"short":true}},[_c('div',{staticClass:"m-5 pt-5"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('audience-admin-dashboard')],1)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }